import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createKudos } from "@/features/kudos/kudos.api";
import type { CreateKudosInput, KudosRow } from "@/features/kudos/schemas/kudos.schema";

/// POST `/workspaces/:workspaceId/kudos`.
///
/// reason: pessimistic mutation (no optimistic write), server-side recipient-
/// membership check + future analysis trigger benefit from a confirmed
/// response. Matches the M4 feedback pattern; kudos are public and
/// consequential, the user expects real confirmation before the card joins
/// the feed.
export function useCreateKudos(workspaceId: string | undefined) {
  const qc = useQueryClient();
  return useMutation<KudosRow, Error, CreateKudosInput>({
    mutationFn: async (input) => {
      if (!workspaceId) throw new Error("workspaceId is required");
      return createKudos(workspaceId, input);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["kudos", workspaceId] });
      void qc.invalidateQueries({ queryKey: ["relationship"] });
    },
  });
}
